<header class="app-header">
  <a
    class="app-header__link app-header__link--desktop"
    routerLink="/about"
    [class.app-header__link--hidden]="!showSideLinks"
  >
    ABOUT
  </a>

  <a
    class="app-header__title"
    routerLink="/"
  >
    DARIA SOLOVEVA
  </a>

  <a
    class="app-header__link app-header__link--desktop"
    routerLink="/contact"
    [class.app-header__link--hidden]="!showSideLinks"
  >
    CONTACT
  </a>
</header>
